import { RecHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import Constants from '@usas/ui-web/utils/Constants';

export const INITIAL_STATE = {
  categoryMeasureId: Constants.DEFAULT_ID,
  isArrayLoading: false,
  isArrayLoaded: false,
  arrayData: [],
  options: [],
  message: ''
};

const getCategoryMeasureMultiselectByCategoryMeasureId = (categoryMeasureId, state, setState) => {
  if (state.isArrayLoading !== true && categoryMeasureId > 0 && !state.message) {
    let newState = {
      ...state,
      categoryMeasureId,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const categoryMeasureIdForUrl = categoryMeasureId ? encodeURIComponent(categoryMeasureId) : 'NaN';
    const url = `/CategoryMeasureDropdown/CategoryMeasure/${categoryMeasureIdForUrl}`;
    RecHttpHelper(url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData: data,
            options: data.map((o) => { return { id: o.categoryMeasureDropdownId, name: o.dropdownValue }; }),
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const CategoryMeasureMultiselectData = { INITIAL_STATE, getCategoryMeasureMultiselectByCategoryMeasureId };

export default CategoryMeasureMultiselectData;